import React from 'react';
import agent from '../../agent';
import GenericInput from '../GenericInput';
import AnyInput from '../GenericInput/AnyInput';
import { SITE_UPDATED } from '../../constants/actionTypes';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
const Promise = global.Promise;

const mapStateToProps = state => ({
  templates: state.templates,
  sites: state.sites,
});

const mapDispatchToProps = dispatch => ({
  updateSite: payload =>
    dispatch({ type: SITE_UPDATED, payload }),
});


class EditSite extends React.Component {
  constructor() {
    super();

    this.state = { 

      columns: [],
      siteData: {
        id: '',
        template: '',
        bridePhoto: '/files/bride.jpeg',
        engagementMapLocation: '',
        weddingLocation: '',
        weddingDatetime: '',
        engagementDatetime: '',
        couplePhoto: '/files/flower.png',
        groom: '',
        bride: '',
        groomPhoto: '/files/groom.jpeg',
        weddingMapLocation: '',
        engagementLocation: '',
      },
    };

    this.updateStateFromEvent = field => ev => {
      const state = this.state;
      const siteData = state.siteData;
      const newSiteData = Object.assign({}, siteData, { [field]: ev.target.value });
      const newState = Object.assign({}, state, {siteData: newSiteData});
      this.setState(newState);
    };
    
    this.updateStateWithValue = (field, value) => {
      const state = this.state;
      const siteData = state.siteData;
      const newSiteData = Object.assign({}, siteData, { [field]: value });
      const newState = Object.assign({}, state, {siteData: newSiteData});
      this.setState(newState);
    };

    this.updateSiteState = (fieldValueObj) => {
      const state = this.state;
      const siteData = { ...state.siteData, ...fieldValueObj};
      const newState = Object.assign({}, state, {siteData});
      console.log('updating site state', fieldValueObj, newState);
      this.setState(newState);
    };

    this.submitForm = ev => {
      ev.preventDefault();
      const siteRequest = Object.assign({}, this.state.siteData);
      this.props.updateSite(agent.Sites.updateSite(siteRequest));
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (((props.templates && props.templates.length > 0 ) || (props.sites && props.sites.length > 0)) && !state.isInitialized) {
      let newColumns = Object.assign({},state.columns);
      let newSiteData = Object.assign({},state.siteData);
      let isSiteUpdated, isColumnUpdated = false;
      props.sites.forEach(site => {
        if(props.match.params.siteId === site.id) {
          newSiteData = Object.assign({}, site);
          isSiteUpdated = true;
        }
      });
      props.templates.forEach(template => {
        if(newSiteData.template === template.name) {
          newColumns = [...template.columns];
          isColumnUpdated = true;
        }
      });
      const newState = Object.assign({}, state, {isInitialized: isSiteUpdated && isColumnUpdated, siteData: newSiteData, columns: newColumns});
      return newState;
    }
    return null;
  }

  render() {
    return (
      <div className="container">
        <h2>Edit Site</h2>
        <br/>
        <div>
          {this.state.columns.map((column, i) => 
            <AnyInput key={column.name} 
              column={column} 
              onChange={this.updateSiteState} 
              value={this.state.siteData[column.name]}/> 
          )}
          <button className="btn btn-primary" onClick={this.submitForm}>
            Update
          </button>
          <Link to={'/sites/list'} className="btn">Cancel</Link>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditSite);
